import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import Amenities from "./components/Amenities";
import BestQuotes from "./components/BestQuotes";
import Carousel from "./components/Carousel";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import NewForm from "./components/NewForm";
import Pricing from "./components/Pricing";

import StripSection from "./components/StripSection";

function App(){
  return(
    <>
    
    <div className="App">
      <Header />
      <Hero />
      <StripSection/>
      {/* <InfoBox /> */}
      <NewForm />

      <Details />

      <Pricing />
      <FloorPlan />
      <Amenities />

      <Carousel />

      <AboutDeveloper />
      <AboutCapitalAcres />
      <BestQuotes />
      <Footer />
      <Form />
    </div>
    </>
  )
}

export default App;
